//@flow
import React from 'react';
import {
  makeStyles,
  Typography,
  Checkbox,
  FormControlLabel,
  Divider,
} from '@material-ui/core';
import {useConversationTags} from '../../chat/utils/conversationTag';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import TiendadaCollapse from '../../../../elements/tiendada-collapse';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import DatePicker from '../../../../elements/DatePicker/DatePicker';

const useStyles = makeStyles(theme => ({
  modalPaper: {
    width: '100%',
    maxWidth: 500,
    padding: '1rem',
    borderRadius: '1rem',
  },
  root: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '1rem',
    minWidth: 300,
  },
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    textAlign: 'center',
  },
  filterList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem',
  },
  footer: {
    display: 'flex',
    gap: '.5rem',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem',
  },
}));

type Props = {
  open: boolean,
  onClose: () => void,
  onApply: () => void,
  onClear: () => void,

  /* filter states */
  startDate?: Date,
  setStartDate: (date: Date | typeof undefined) => void,
  endDate?: Date,
  setEndDate: (date: Date | typeof undefined) => void,
  lastMessageDate?: Date,
  setLastMessageDate: (date: Date | typeof undefined) => void,
  selectedTags?: string[],
  setSelectedTags: (string[]) => void,
  selectedChannel?: string,
  setSelectedChannel: (value: string | typeof undefined) => void,
  selectedState?: string,
  setSelectedState: (value: string | typeof undefined) => void,
};

const MESSAGE_SERVICES = [
  {
    value: 'WHATSAPP_WEB',
    name: 'WHATSAPP_WEB',
    label: 'whatsapp web',
  },
  {
    value: 'FB_MESSENGER',
    name: 'FB_MESSENGER',
    label: 'facebook',
  },
  {
    value: 'INSTAGRAM',
    name: 'INSTAGRAM_DIRECT',
    label: 'instagram',
  },
];

const CONVERSATION_STATE = [
  {
    label: 'Abierto',
    value: 'OPEN',
  },
  {
    label: 'Cerrado',
    value: 'CLOSED',
  },
];

export default function ContactModalFilter(props: Props) {
  const {
    onApply,
    onClear,
    onClose,
    open,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    lastMessageDate,
    setLastMessageDate,
    selectedTags,
    setSelectedTags,
    selectedChannel,
    setSelectedChannel,
    selectedState,
    setSelectedState,
  } = props;

  const classes = useStyles();

  const {conversationTags} = useConversationTags();

  const handleChangeStartDate = date => {
    setStartDate(date);
  };

  const handleChangeEndDate = date => {
    setEndDate(date);
  };
  const clearFilters = () => {
    setStartDate();
    setEndDate();
    setLastMessageDate();
    setSelectedTags([]);
    setSelectedChannel();
    setSelectedState();

    onClear();
  };

  // const {collaborators} = useCollaborators();

  return (
    <CustomModal
      open={open}
      handleCloseModal={onClose}
      classes={{
        paper: classes.modalPaper,
      }}
    >
      <aside className={classes.root}>
        <header className={classes.header}>
          <Typography className={classes.title}>Filtros</Typography>
        </header>

        <div className={classes.content}>
          <Divider className={classes.divider} />

          <TiendadaCollapse title="Fecha de creación" startOpen>
            <div className={classes.filterList}>
              <DatePicker
                label="Desde"
                handleChange={handleChangeStartDate}
                value={startDate ?? null}
              />

              <DatePicker
                disabled={!startDate}
                label="Hasta"
                handleChange={handleChangeEndDate}
                value={endDate ?? null}
                minDate={startDate}
                minDateMessage={
                  'La fecha debe ser posterior a la fecha de inicio'
                }
              />
            </div>
          </TiendadaCollapse>
          <Divider className={classes.divider} />

          <TiendadaCollapse title="Fecha de último mensaje" startOpen>
            <div className={classes.filterList}>
              <DatePicker
                label="Seleccionar fecha"
                handleChange={setLastMessageDate}
                value={lastMessageDate ?? null}
              />
            </div>
          </TiendadaCollapse>
          <Divider className={classes.divider} />

          <TiendadaCollapse title="Etiqueta">
            {conversationTags.length > 0 && (
              <div className={classes.filterList}>
                {conversationTags.map(tag => {
                  const exist =
                    Array.isArray(selectedTags) &&
                    selectedTags.includes(tag.tag);

                  return (
                    <FormControlLabel
                      key={tag.id}
                      classes={{
                        root: classes.controlLabel,
                        label: classes.greyText,
                      }}
                      control={
                        <Checkbox
                          classes={{root: classes.checkbox}}
                          checked={exist}
                          color="primary"
                          onClick={() => {
                            const prevTags = Array.isArray(selectedTags)
                              ? selectedTags
                              : [];
                            if (exist) {
                              setSelectedTags(
                                prevTags.filter(t => t !== tag.tag)
                              );
                            } else {
                              setSelectedTags([...prevTags, tag.tag]);
                            }
                          }}
                        />
                      }
                      label={tag.tag}
                    />
                  );
                })}
                {conversationTags.length === 0 && (
                  <Typography className={classes.greyText}>
                    No hay etiquetas
                  </Typography>
                )}
              </div>
            )}
          </TiendadaCollapse>
          <Divider className={classes.divider} />

          <TiendadaCollapse title="Canal (Seleccionar uno)" startOpen>
            <div className={classes.filterList}>
              {MESSAGE_SERVICES.map(messageState => {
                const handleClick = () => {
                  if (selectedChannel === messageState.value) {
                    setSelectedChannel();
                  } else {
                    setSelectedChannel(messageState.value);
                  }
                };

                return (
                  <FormControlLabel
                    key={messageState.value}
                    classes={{
                      root: classes.controlLabel,
                      label: classes.greyText,
                    }}
                    checked={selectedChannel === messageState.value}
                    control={
                      <Checkbox
                        classes={{root: classes.checkbox}}
                        color="primary"
                        onClick={handleClick}
                      />
                    }
                    label={messageState.label}
                  />
                );
              })}
            </div>
          </TiendadaCollapse>

          <Divider className={classes.divider} />
          <TiendadaCollapse title="Estado (Seleccionar uno)" startOpen>
            <div className={classes.filterList}>
              {CONVERSATION_STATE.map(state => {
                return (
                  <FormControlLabel
                    classes={{
                      root: classes.controlLabel,
                      label: classes.greyText,
                    }}
                    control={
                      <Checkbox
                        classes={{root: classes.checkbox}}
                        color="primary"
                        onClick={() => {
                          if (selectedState === state.value) {
                            setSelectedState();
                          } else {
                            setSelectedState(state.value);
                          }
                        }}
                        checked={selectedState === state.value}
                      />
                    }
                    label={state.label}
                  />
                );
              })}
            </div>
          </TiendadaCollapse>
          <Divider className={classes.divider} />
        </div>

        <footer className={classes.footer}>
          <CustomButton color="primary" onClick={clearFilters} fullWidth>
            Limpiar
          </CustomButton>
          <CustomButton
            variant="contained"
            color="primary"
            onClick={onApply}
            fullWidth
          >
            Filtrar
          </CustomButton>
        </footer>
      </aside>
    </CustomModal>
  );
}
